import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=846f2ba6&scoped=true"
import script from "./paymentPage.vue?vue&type=script&lang=js"
export * from "./paymentPage.vue?vue&type=script&lang=js"
import style0 from "./paymentPage.vue?vue&type=style&index=0&id=846f2ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846f2ba6",
  null
  
)

export default component.exports